module.exports = __webpack_public_path__ + "static/logo-mobile.0bffbae5.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/components/Nav/imgs/logo-mobile.png
// module id = 2740
// module chunks = 0